import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';
import { Shield } from 'lucide-react';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [credentials, setCredentials] = useState({ username: '', password: '' });

  const handleLogin = (e) => {
    e.preventDefault();
    // Mock authentication - in real app, this would call backend
    if (credentials.username === 'admin' && credentials.password === 'admin123') {
      localStorage.setItem('isAdminAuthenticated', 'true');
      toast({
        title: "Login Successful",
        description: "Welcome back!",
      });
      navigate('/admin/dashboard');
    } else {
      toast({
        title: "Login Failed",
        description: "Invalid credentials. Try admin/admin123",
        variant: "destructive"
      });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f8fafc] to-white flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <img src="https://customer-assets.emergentagent.com/job_cabinet-hero/artifacts/3942icok_image.png" alt="Cabinet Hero" className="h-16 w-16" />
            <span className="text-3xl font-bold text-[#1e3a8a]">Cabinet Hero</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-gray-600">
            <Shield className="w-5 h-5" />
            <span className="font-semibold">Admin Portal</span>
          </div>
        </div>
        
        <Card className="border-2">
          <CardHeader>
            <CardTitle className="text-2xl text-center text-[#1e3a8a]">Login</CardTitle>
            <CardDescription className="text-center">Enter your credentials to access the dashboard</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleLogin} className="space-y-4">
              <div>
                <Label htmlFor="username">Username</Label>
                <Input 
                  id="username"
                  value={credentials.username}
                  onChange={(e) => setCredentials(prev => ({...prev, username: e.target.value}))}
                  required
                  className="mt-2"
                />
              </div>
              <div>
                <Label htmlFor="password">Password</Label>
                <Input 
                  id="password"
                  type="password"
                  value={credentials.password}
                  onChange={(e) => setCredentials(prev => ({...prev, password: e.target.value}))}
                  required
                  className="mt-2"
                />
              </div>
              <Button type="submit" className="w-full bg-[#1e3a8a] hover:bg-[#1e40af]">
                Sign In
              </Button>
              <p className="text-xs text-center text-gray-500 mt-4">
                Demo: admin / admin123
              </p>
            </form>
          </CardContent>
        </Card>
        
        <div className="text-center mt-6">
          <Button variant="ghost" onClick={() => navigate('/')} className="text-[#1e3a8a]">
            ← Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;